import { render, staticRenderFns } from "./ContractMinimumWageConfiguration.vue?vue&type=template&id=5f97a910&scoped=true"
import script from "./ContractMinimumWageConfiguration.vue?vue&type=script&lang=js"
export * from "./ContractMinimumWageConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ContractMinimumWageConfiguration.vue?vue&type=style&index=0&id=5f97a910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f97a910",
  null
  
)

export default component.exports